import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

function MonthPicker({ month, onMonthPicked}) {

    const [t] = useTranslation(["global"])
    const [selectedMonth, setSelectedMonth] = useState(month)

    useEffect(() => {
        console.log("Selected Month CHANGED!")
    }, [selectedMonth])

    const handleApply = () => {
        if (selectedMonth) {
            onMonthPicked(selectedMonth)
            console.log(`Mont Applyed: ${selectedMonth}`)
        }
    }

    const handleMonth = (e) => {
        setSelectedMonth(e.target.value)
    }

    console.log("MonthPicker RENDERED!")

    let buttonColor;
    let buttonText = t("action.apply")

    if (selectedMonth == null) {
        buttonColor = 'gray'
    } else if (selectedMonth === month) {
        buttonColor = 'gray'
    } else {
        buttonColor = 'orange'
    }

    return (
        <section>
            <div className="row">
                <div className="col-sm text-center">
                    <div className="card bg-dark bg-opacity-50 text-white mb-4" id="absence-request">

                        <div className="card-body  ">
                            <div className="mx-auto">
                                <h4>{t("helper.select_period")}:</h4>
                                <input className="p-2 m-2" type="month" min="2023-01" onChange={handleMonth} value={selectedMonth} />
                            
                                <button className="btn" style={{ background: buttonColor }} onClick={handleApply}>{buttonText}</button>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MonthPicker